import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import CreatorOrganizations from "../widgets/creatorOrganizations";
import InjectionScripts from "../widgets/injectionScripts";
import OrganizationFeedbackStatusOverview from "../widgets/organizationFeedbackStatusOverview";

const CreatorPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Omniscia Health" />
      <PortalGridContent>
        <Grid size={{ xs: 12, sm: 18, md: 6, lg: 5 }}>
          <CreatorOrganizations />
        </Grid>

        <Grid size={{ xs: 12, sm: 18, md: 6, lg: 7 }}>
          <InjectionScripts />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <OrganizationFeedbackStatusOverview />
        </Grid>

        <Grid size={{ xs: 12 }} />
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  awsGroup: state.userSession.awsGroup,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreatorPortal));
